export default "__VITE_ASSET__BUlq2FIx__"